import { NmLoader } from '../components/NmLoader';
import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { DEFAULT_LOCALE, normalizeLocale } from '../i18n/config';
import { initI18n, i18n } from '../i18n/init';
import { getPlatformStore } from '../platform';
import { LocaleProvider } from '../context/LocaleContext';

/**
 * Boots i18next before rendering the app tree.
 * LocaleProvider handles API merge + runtime language switches.
 */
export function I18nRoot({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    void (async () => {
      let locale = DEFAULT_LOCALE;
      locale = normalizeLocale(await getPlatformStore().getLocale());
      await initI18n(locale);
      setReady(true);
    })();
  }, []);

  if (!ready) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <NmLoader size="lg" decorative />
      </div>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <LocaleProvider>{children}</LocaleProvider>
    </I18nextProvider>
  );
}
